/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Ac_TitleInputs */

const en_pc_cmp_ac_title = /** @type {(inputs: Pc_Cmp_Ac_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When Acrobat is still the better choice`)
};

const zh_pc_cmp_ac_title = /** @type {(inputs: Pc_Cmp_Ac_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些情况仍建议使用 Acrobat`)
};

/**
* | output |
* | --- |
* | "When Acrobat is still the better choice" |
*
* @param {Pc_Cmp_Ac_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_ac_title = /** @type {((inputs?: Pc_Cmp_Ac_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Ac_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_ac_title(inputs)
	return zh_pc_cmp_ac_title(inputs)
});
export { pc_cmp_ac_title as "pc.cmp.ac_title" }